<div class="right-panel flex-fill d-flex flex-column">
    <div class="right-panel-body flex-fill overflow-y-auto custom-scrollbar" style="background-color: #e6e6e6;">
        <div class="row">
            <div class="col-6 mx-auto">
                <mat-card appearance="outlined" style="padding-bottom:15px">
                    <mat-card-header>
                            <mat-card-title>Events</mat-card-title>

                    </mat-card-header>
                                <div class="d-flex align-items-center w-100 gap-3 ps-2 pe-2">
                                    <mat-form-field class="flex-fill mb-0">
                                        <mat-label>Search by name or event</mat-label>
                                        <input matInput [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}" id="event-search">
                                        @if (searchTerm) {
                                            <button matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm = ''">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        }
                                    </mat-form-field>
                                    <mrs-btn-icon buttonLabel="Add" buttonId="addButton" (onClick)="addAccountEvent()" iconName="add"></mrs-btn-icon>
                                </div>                    
                    <mat-card *ngFor="let event of filteredEvents" class="mt-3" appearance="outlined" [ngClass]="{'event-card': selectedEvent != event}">
                        <mat-card-content>
                            <div class="flex flex-row" (click)="selectEvent(event)" id="event-card">
                                <mat-slide-toggle [checked]="event.isActive" (change)="eventActiveToggled(event)" class="me-2">
                                </mat-slide-toggle>
                                <span>{{ event.name }}</span>
                                <div class="flex-1"></div>
                                <div style="justify-content: flex-end">
                                    @if (event.id != null) {
                                        <i aria-hidden="true" class="fa fa-trash" (click)="deleteAccountEvent(event)"
                                            id="delete-event"></i>
                                    }
                                </div>
                            </div>
                            @if (selectedEvent === event) {
                                <form class="px-5 py-3" [formGroup]="eventForm" (ngSubmit)="saveAccountEvent()" novalidate autocomplete="off">

                                    <mat-form-field class="w-100">
                                        <mat-label>Name</mat-label>
                                        <input matInput formControlName='name' id="event-name">
                                        @if (formSubmitted && eventForm.get('name').hasError('required')) {
                                            <mat-error>Name <strong>required</strong></mat-error>
                                        }
                                    </mat-form-field>

                                    <auto-suggest
                                        id="system-event"
                                        field="name"
                                        dataKey="id"
                                        formControlName="systemEventId"
                                        placeholder="System Event"
                                        [list]="eventTypes"
                                        optionDisabled="disabled"
                                        tooltipField="disabledTooltip"
                                        [showRequiredError]="formSubmitted && eventForm.get('systemEventId').hasError('required')">
                                    </auto-suggest>
                                    @if (showSingleEventCondition) {
                                        <mat-form-field class="w-100">
                                            <mat-label>{{eventConditionLabel}}</mat-label>
                                                <mat-select formControlName="conditionId">
                                                    <mat-option *ngFor="let eventCondition of eventConditions"
                                                        [value]="eventCondition.id">{{eventCondition.name}}</mat-option>
                                                </mat-select>
                                                @if (eventConditionHint) {
                                                    <i matSuffix mat-icon-button aria-label="Info" [matTooltip]="eventConditionHint">
                                                        <mat-icon style="height:18px; width: 18px; font-size: 18px; color: #6A6A6A">info</mat-icon>
                                                    </i>
                                                }
                                            </mat-form-field>
                                    }
                                    
                                    @if (showMultiEventCondition) {
                                        <div class="d-flex align-items-center gap-1">
                                            <auto-suggest class="flex-fill"
                                                    id="system-event-condition"
                                                    field="name" dataKey="id"
                                                    formControlName="conditionId"                                            
                                                    [list]="eventConditions"
                                                    [placeholder]="eventConditionLabel"
                                                    [multiple]="multipleEventConditions"   
                                                    [showCheckboxes]="multipleEventConditions"       
                                                    [showRequiredError]="formSubmitted && eventForm.get('conditionId').hasError('required')">
                                                </auto-suggest>
                                            @if (eventConditionHint) {
                                                <mat-icon class="field-hint-icon" aria-label="Info" [matTooltip]="eventConditionHint">info</mat-icon>
                                            }
                                        </div>
                                    }

                                    @for (conditionGroup of multiNamedEventConditions; track conditionGroup.formControlName) {
                                        @if (!conditionGroup.conditionalOnParam || eventForm.get(conditionGroup.conditionalOnParam)?.value?.length > 0) {
                                            <auto-suggest
                                                field="name" dataKey="id"
                                                [list]="getConditionGroupOptions(conditionGroup)"
                                                [placeholder]="conditionGroup.param.label"
                                                [formControlName]="conditionGroup.formControlName"
                                                [multiple]="conditionGroup.param.multiple !== false"
                                                [showCheckboxes]="conditionGroup.param.multiple !== false"
                                                [showRequiredError]="formSubmitted && eventForm.get(conditionGroup.formControlName)?.hasError('required')">
                                            </auto-suggest>
                                        }
                                    }

                                     @if (mapkeyCondition) {
                                        <div class="d-flex align-items-center gap-1">
                                            <map-keys-dropdown class="flex-fill"
                                                [displayList]="mapKeys" [placeholder]="mapkeyConditionParams.label"
                                                [formControlName]="mapkeyConditionParams.name" 
                                                [formControl]="eventForm.get(mapkeyConditionParams.name)"
                                                [showRequiredError]="eventForm.get(mapkeyConditionParams.name).hasError('required')">
                                            </map-keys-dropdown>
                                            @if (mapkeyConditionParams.hint) {
                                                <mat-icon class="field-hint-icon" aria-label="Info" [matTooltip]="mapkeyConditionParams.hint">info</mat-icon>
                                            }
                                        </div>
                                    }

                                    @if (dateFieldCondition) {
                                        <div class="d-flex align-items-center gap-1">
                                            <mat-form-field class="w-100 flex-fill">
                                                <mat-label>{{dateFieldConditionParams.label}}</mat-label>
                                                <mat-select [formControlName]="dateFieldConditionParams.name">
                                                    <mat-option value="">Case Creation Date</mat-option>
                                                    <mat-option *ngFor="let mapKey of dateFieldMapKeys" [value]="mapKey.id">{{mapKey.entityHierarchy}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            @if (dateFieldConditionParams.hint) {
                                                <mat-icon class="field-hint-icon" aria-label="Info" [matTooltip]="dateFieldConditionParams.hint">info</mat-icon>
                                            }
                                        </div>
                                    }

                                    @if (tagCondition) {
                                        <object-tags [(tags)]="selectedTags" [account]="accountInfo"></object-tags>
                                    }

                                    @if (inputCondition) {
                                        @for (inputParam of inputConditionParams; track inputParam.name) {
                                            <div class="d-flex align-items-center gap-1">
                                                <mat-form-field class="w-100 flex-fill">
                                                    <mat-label>{{inputParam.label}}</mat-label>
                                                    <input matInput [formControlName]='inputParam.name' [id]="inputParam.name"
                                                        [type]="inputParam.inputType || 'text'"
                                                        [min]="inputParam.min" [max]="inputParam.max">
                                                    @if (formSubmitted && eventForm.get(inputParam.name).hasError('required')) {
                                                        <mat-error>{{inputParam.label}} <strong>required</strong></mat-error>
                                                    }
                                                    @if (eventForm.get(inputParam.name).hasError('max')) {
                                                        <mat-error>{{inputParam.label}} cannot be more than <strong>{{inputParam.max}}</strong></mat-error>
                                                    }
                                                    @if (eventForm.get(inputParam.name).hasError('min')) {
                                                        <mat-error>{{inputParam.label}} cannot be less than <strong>{{inputParam.min}}</strong></mat-error>
                                                    }
                                                </mat-form-field>
                                                @if (inputParam.hint) {
                                                    <mat-icon class="field-hint-icon" aria-label="Info" [matTooltip]="inputParam.hint">info</mat-icon>
                                                }
                                            </div>
                                            @if (inputParam.lessThanParam && eventForm.hasError(lessThanErrorKey(inputParam.name))) {
                                                <mat-error class="cross-field-error">{{inputParam.label}} must be less than <strong>{{inputParam.lessThanLabel || inputParam.lessThanParam}}</strong></mat-error>
                                            }
                                        }
                                    }

                                    <div class="flex flex-row">
                                        <auto-suggest style="flex: 1" [list]="filteredActions" placeholder="Action" field="name"
                                            dataKey="id" formControlName="systemEventActionId" id="system-event-action"
                                            [showRequiredError]="formSubmitted && eventForm.get('systemEventActionId').hasError('required')">
                                        </auto-suggest>
                                        @if (canEditSelectedAction) {
                                            <i aria-hidden="true"
                                                class="fa fa-pencil-alt m-2"
                                                (click)="editAction(event)"
                                                style="margin-right: -24px !important; cursor: pointer; padding-top:6px;"></i>
                                        }
                                    </div>
                                    @if (showActionConditionSelector) {
                                        <auto-suggest
                                            [list]="actionConditions" [placeholder]="actionConditionLabel" [field]="conditionNameField"
                                                [dataKey]="conditionIdField"
                                            formControlName="actionConditionId" id="system-action-condition"
                                            [multiple]="multipleActionConditions"
                                            [showCheckboxes]="multipleActionConditions"
                                            [showRequiredError]="conditionIsRequired && formSubmitted && eventForm.get('actionConditionId').hasError('required')">
                                        </auto-suggest>
                                    }
                                    @if (toggleConditions) {
                                        <div class="flex flex-row">
                                            <mat-slide-toggle id="toggleCondition" [formControlName]="this.toggleConditions.name">
                                                {{toggleConditionLabel}}</mat-slide-toggle>
                                        </div>
                                    }
                                    <div class="d-flex align-items-center gap-1">
                                        <auto-suggest class="flex-fill" [list]="rules" placeholder="Rule" field="name" dataKey="id" formControlName="ruleId"
                                            id="system-event-rule" 
                                            [showRequiredError]="formSubmitted && eventForm.get('systemEventId').value === timerTriggerEnum && eventForm.get('ruleId').hasError('required')">
                                        </auto-suggest>
                                        @if (eventForm.get('systemEventId').value === timerTriggerEnum) {
                                            <mat-icon class="field-hint-icon" aria-label="Info"
                                                matTooltip="This rule is evaluated hourly against every candidate case found by the search settings above; only cases where it evaluates true will have the action below performed.">info</mat-icon>
                                        }
                                    </div>
                                    <div class="pt-4 flex" style="justify-content: flex-end;align-items: center;">
                                        <mrs-btn-tertiary buttonLabel=" Cancel" buttonId="cancelBtn" (onClick)="cancelEvent(event)">
                                        </mrs-btn-tertiary>
                                        <mrs-btn-primary buttonLabel="Save" buttonId="saveBtn" (onClick)="submit" type="submit"
                                            id="system-event-save">
                                        </mrs-btn-primary>
                                    </div>
                                </form>
                            }
                        </mat-card-content>
                    </mat-card>
                </mat-card>
                @if (showNoEventsState) {
                    <div class="no-events-mat-card-content">
                        <br />
                        <h2>No Events</h2>
                        <br />
                        <label>To get started, add a new event.</label>
                        <br />
                        <br />
                        <mrs-btn-outline buttonLabel="ADD A NEW EVENT" buttonId="addButtonOutlined" (onClick)="addAccountEvent()" iconName="add" textColor="#2C6EED"></mrs-btn-outline>
                    </div>
                }
            </div>
        </div>
    </div>
</div>